import { MessageSquareDashed } from 'lucide-react'
import { useT } from './hooks'

export default function ChatEmpty() {
  const { t } = useT({ keyPrefix: 'chat' })
  return (
    <div className="my-8 flex h-full flex-1 flex-col items-center justify-center gap-4 text-gray-400">
      <MessageSquareDashed className="h-12 w-12" />
      {t('empty')}.
    </div>
  )
}
